import { useContext } from 'react';
import{ AuthContext} from '../context/';

function useAuth() {
  const { isAuth, setIsAuth } = useContext(AuthContext);
  return { isAuth, setIsAuth };
}

export default useAuth;
